import React from "react";

const DeliveryTextInput = ({
  label,
  icon: Icon,
  placeholder,
  name,
  value,
  error,
  onChange,
}) => {
  const isMobileField = name === "senderMobile" || name === "receiverMobile";

  return (
    <div className="group">
      <label className="mb-1 block text-[12px] font-semibold text-slate-500">
        {label}
      </label>

      <div
        className={`flex h-[44px] items-center gap-2 rounded-xl border bg-white px-3 transition-all duration-300 group-focus-within:border-blue-400 group-focus-within:ring-4 group-focus-within:ring-blue-100 ${
          error ? "border-red-300" : "border-slate-200"
        }`}
      >
        {Icon && <Icon size={16} className="shrink-0 text-slate-400" />}

        <input
          type={isMobileField ? "tel" : "text"}
          inputMode={isMobileField ? "numeric" : "text"}
          maxLength={isMobileField ? 10 : undefined}
          value={value || ""}
          onChange={(e) => onChange(name, e.target.value)}
          className="w-full bg-transparent text-[14px] text-slate-700 outline-none placeholder:text-slate-400"
          placeholder={placeholder || label}
        />
      </div>

      <div className="min-h-[10px]">
        {error && (
          <p className="mt-1 text-[11px] font-medium text-red-500">
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default DeliveryTextInput;